export enum CommentType {
  Comment = 'Comment',
  Suggestion = 'Suggestion',
}
